<template>
  <vxe-grid
    ref="refTable"
    :columns="tableColumn"
    :data="list"
    :min-height="30"
    :rowConfig="{
      isCurrent: false
    }"
  >
  </vxe-grid>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableColumn: [
        {
          title: '序号',
          type: 'seq',
          width: 50
        },
        {
          title: '物料名称',
          field: 'name'
        },
        {
          title: '规格',
          field: 'spec'
        },
        {
          title: '单位',
          field: 'unit'
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'goods_price'
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        },
        {
          title: '仓位',
          field: 'warehuose_name',
          width: 200
        },
        {
          title: '备注',
          field: 'remark'
        }
      ]
    }
  }
}
</script>

<style scoped>
.table-main {
}
</style>
